import { CATEGORIES_ACTION_TYPES } from "./actionTypes";
import {
    normalizeItems,
} from "../utility";

const initialState = {
    byId: {},
    allIds: [],
    items: [],

    subcategories: {},

    loading: {
        list: false,
        items: {},
        subcategories: {},
    },

    error: {
        list: null,
        items: {},
        subcategories: {},
    },

    filters: {},

    lastUpdated: null,
}

export const categoriesReducer = (state = initialState, action) => {
    switch (action.type) {
        case CATEGORIES_ACTION_TYPES.FETCH_LIST_REQUEST: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    list: true,
                },
                error: {
                    ...state.error,
                    list: null,
                }
            }
        }
        case CATEGORIES_ACTION_TYPES.FETCH_LIST_SUCCESS: {
            const { data } = action.payload;
            const { byId, allIds } = normalizeItems(data);

            return {
                ...state,
                byId,
                allIds,
                items: data,
                loading: {
                    ...state.loading,
                    list: false,
                },
                error: {
                    ...state.error,
                    list: null,
                },
                lastUpdated: action.meta.timestamp,
            };
        }
        case CATEGORIES_ACTION_TYPES.FETCH_LIST_FAILURE: {
            return {
                ...state,
                loading: {
                    ...state.loading,
                    list: false,
                },
                error: {
                    ...state.error,
                    list: action.payload.error,
                },
            };
        }
        case CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_REQUEST: {
            const { parentId } = action.payload;
            return {
                ...state,
                loading: {
                    ...state.loading,
                    subcategories: { ...state.loading.subcategories, [parentId]: true },
                },
                error: {
                    ...state.error,
                    subcategories: { ...state.error.subcategories, [parentId]: null },
                },
            };
        }
        case CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_SUCCESS: {
            const { parentId, data } = action.payload;
            return {
                ...state,
                subcategories: { ...state.subcategories, [parentId]: data },
                loading: {
                    ...state.loading,
                    subcategories: { ...state.loading.subcategories, [parentId]: false },
                },
            };
        }
        case CATEGORIES_ACTION_TYPES.FETCH_SUBCATEGORIES_FAILURE: {
            const { parentId, error } = action.payload;
            return {
                ...state,
                subcategories: { ...state.subcategories, [parentId]: [] },
                loading: {
                    ...state.loading,
                    subcategories: { ...state.loading.subcategories, [parentId]: false },
                },
                error: {
                    ...state.error,
                    subcategories: { ...state.error.subcategories, [parentId]: error },
                },
            };
        }
        default:
            return state;
    }
}